<template>
<div class="display-group mb-3" :class="mainClass">
  <div class="label-class text-info">{{label}}</div>
  <div class="slot-wrapper">
  <slot></slot>
  </div>
</div>
</template>

<script>
export default {
  name: 'DisplayField',
  props: {
    label: String,
    groupClass: String
  },
  data () {
    return {
      mainClass: '',
      slotwrapperelem: null
    }
  },
  mounted () {
    if (this.groupClass) {
      this.mainClass = this.groupClass
    } else {
      this.mainClass = 'col col-12'
    }
  }
}
</script>

<style scoped>
.label-class { font-size: 75%; margin-bottom: 1px; }
.display-group { border-bottom: 1px dotted; border-color: #d9d9d9; }
.slot-wrapper { min-height: 1.5em; }
</style>
